import { useAdvert } from "./use-advert";
import { FPADataQuery_search_Search_advert_Advert_dealer_Dealer } from "../../connected-components/hoc/query/__generated__/fpa-page-data.query";

export const useDealer =
  (): FPADataQuery_search_Search_advert_Advert_dealer_Dealer | null => {
    const { dealer = null } = useAdvert(); // eslint-disable-line no-restricted-syntax

    return dealer;
  };
